import { Component, ElementRef, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NotifyService } from '../../services/notify.service';

@Component({
  selector: 'split-file-upload',
  templateUrl: './split-file-upload.component.html',
  styleUrls: ['./split-file-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SplitFileUploadComponent,
      multi: true
    }
  ]
})
export class SplitFileUploadComponent implements ControlValueAccessor {

  onChange!: Function;
  public file: File | null = null;

  public name: string | undefined = ''

  @HostListener('change', ['$event.target.files']) emitFiles( event: FileList ) {
    const file = event && event.item(0);
    const maxSizeInByte = 5242880

    if(file!.size > maxSizeInByte){
      this.notify.emitWarn('Arquivo Grande Demais, O Tamanho Máximo Permitido é 5MB.')
      return
    }

    this.onChange(file);
    this.file = file;
    this.name = file?.name;
  }

  @ViewChild('fileupload') fileupload!: ElementRef;

  @Output() onClick = new EventEmitter();

  constructor( 
    private host: ElementRef<HTMLInputElement>,
    private notify: NotifyService
  ) {
  }

  handleClick(fileupload: any) {
    this.onClick.emit(fileupload);
  }

  writeValue( value: any ) {
    console.log(value);
    // clear file input
    this.host.nativeElement.value = '';
    this.file = null;
    this.name = value;
  }

  registerOnChange( fn: Function ) {
    this.onChange = fn;
  }

  registerOnTouched( fn: Function ) {
  }


}
